export default "__VITE_ASSET__F8fa46J5__"